import { CheckIcon } from '@heroicons/react/outline';
import InformationTab from 'components/InformationTab';
import LoadingTable from 'components/LoadingTable';
import SelectableField from 'components/SelectableField';
import TableButton from 'components/TableButton';
import TableNavigator from 'components/TableNavigator';
import TableResults from 'components/TableResults';
import useActions from 'hooks/useActions';
import { useEffect } from 'react';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        sequences: state.PESequences.sequences,
        page: state.PESequences.page,
        per_page: state.PESequences.per_page,
        total: state.PESequences.total,
        total_pages: state.PESequences.total_pages,
        isLoading: state.PESequences.isLoadingSequences,
        selectedRegionFilter: state.user.selectedRegion,
    };
}

const PESequencesModalContent = connect(mapStateToProps)(function (props) {
    const {
        sequences,
        page,
        per_page,
        total,
        total_pages,
        isLoading,
        onSelect = function () {},
        selectedRegionFilter,
    } = props;

    const { PE_FETCH_SEQUENCES_REQUEST } = useActions();

    function onNext() {
        PE_FETCH_SEQUENCES_REQUEST({
            page: page + 1,
            per_page,
        });
    }

    function onPrev() {
        PE_FETCH_SEQUENCES_REQUEST({
            page: page - 1,
            per_page,
        });
    }

    function onPageSelected(pageSelected) {
        PE_FETCH_SEQUENCES_REQUEST({
            page: pageSelected,
            per_page,
        });
    }

    function onPerPageSelected({ perPage }) {
        PE_FETCH_SEQUENCES_REQUEST({
            per_page: perPage,
        });
    }

    useEffect(() => {
        PE_FETCH_SEQUENCES_REQUEST();
        // eslint-disable-next-line
    }, [selectedRegionFilter]);

    function DataTable() {
        return (
            <section>
                <TableResults results={total} />
                <LoadingTable isLoading={isLoading}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Tags</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sequences.map((sequence) => (
                            <tr>
                                <td>
                                    <SelectableField
                                        text={sequence.name}
                                        url={`/program-engine/sequences/${sequence.id}`}
                                    />
                                </td>
                                <td className="tags">
                                    <div className="tagbox">
                                        {sequence.tags?.map((tag) => (
                                            <div
                                                className="tag"
                                                key={`tag-${sequence.id}-${tag.id}`}
                                            >
                                                {tag.name}
                                            </div>
                                        ))}
                                    </div>
                                </td>
                                <td>
                                    <TableButton
                                        className="select-button"
                                        action={() => {
                                            onSelect(sequence.id);
                                        }}
                                    >
                                        <CheckIcon
                                            height={'1.3rem'}
                                            style={{ marginRight: '0.5rem' }}
                                        />
                                        Select
                                    </TableButton>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </LoadingTable>
                <TableNavigator
                    currentPage={page}
                    totalPages={total_pages}
                    onPageSelected={onPageSelected}
                    onNext={onNext}
                    onPrev={onPrev}
                />
            </section>
        );
    }

    return (
        <section className="p-4">
            <InformationTab
                dataTable={<DataTable />}
                showPrograms={false}
                sectionName="Sequences"
                perPage={per_page}
                onPerPageSelected={onPerPageSelected}
            />
        </section>
    );
});

export default PESequencesModalContent;
